import styled from 'styled-components/macro'

export const Wrap = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 37.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;
`
